const isMac = typeof navigator !== 'undefined' && /Mac|iP(hone|ad|od)/.test(navigator.platform)

// Display hint for the palette hotkey (⌘K on Mac, Ctrl K elsewhere).
export const searchHotkeyHint = isMac ? '⌘K' : 'Ctrl K'

// True when a keydown event is the global-search hotkey (Cmd/Ctrl+K — the
// de-facto standard palette shortcut: Slack, Notion, Linear, GitHub).
export const isSearchHotkey = (event) =>
  event.key.toLowerCase() === 'k' && (event.metaKey || event.ctrlKey) && !event.altKey
